var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrograma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 187.1 187.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#221e20;}.cls-2{fill:url(#Degradado_sin_nombre_14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_14",
    x1: 0,
    y1: 93.55,
    x2: 187.1,
    y2: 93.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#28aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006496"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.55,187.1C41.97,187.1,0,145.14,0,93.55S41.97,0,93.55,0s93.55,41.97,93.55,93.55-41.97,93.55-93.55,93.55Zm0-178.76C46.57,8.34,8.34,46.57,8.34,93.55s38.22,85.21,85.21,85.21,85.21-38.22,85.21-85.21S140.54,8.34,93.55,8.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.18,126.27h-57.74c-5.54,0-10.05-3.59-10.05-8v-41.16c0-4.42,4.51-8.01,10.05-8.01h57.74c5.54,0,10.05,3.59,10.05,8.01v41.16c0,4.41-4.51,8-10.05,8Zm-57.74-53.1c-2.73,0-4.94,1.77-4.94,3.94v41.16c0,2.17,2.22,3.94,4.94,3.94h57.74c2.73,0,4.94-1.77,4.94-3.94v-41.16c0-2.17-2.22-3.94-4.94-3.94h-57.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.42,
    y: 58.52,
    width: 11.61,
    height: 17.24,
    rx: 1.03,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 106.26,
    y: 58.52,
    width: 11.61,
    height: 17.24,
    rx: 1.03,
    ry: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.2,
    y: 85.6,
    width: 11.61,
    height: 9.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.31,
    y: 85.6,
    width: 11.61,
    height: 9.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.2,
    y: 103.05,
    width: 11.61,
    height: 9.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 98.31,
    y: 103.05,
    width: 11.61,
    height: 9.25
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrograma);
export default __webpack_public_path__ + "static/media/programa.d7494e5517e0410ce313ef0ec3e9c212.svg";
export { ForwardRef as ReactComponent };